import React from "react";
import { Fragment } from "react";

import classes from "./NavigationItems.css";
import NavigationItem from "./NavigationItem/NavigationItem";

function navigationItems(props) {
  let items = (
    <ul className={classes.NavigationItems}>
      {props.isAuthenticated ? (
        <Fragment>
          <NavigationItem link="/logout">Logout</NavigationItem>
          {/* <NavigationItem link="/">Menu</NavigationItem> */}
        </Fragment>
      ) : (
        <NavigationItem link="/auth">LogIn</NavigationItem>
      )}
    </ul>
  );

  if (props.agencyCode !== "admin") items = null;

  return <div>{items}</div>;
}

export default navigationItems;
